import { html, LitElement, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';

export interface Asset {
    title: string;
    alt: string;
    src: string;
	thumbnailSrc: string;
    width: number;
    height: number;
}

@customElement('image-switcher')
export class ImageSwitcher extends LitElement {

    // Props

    @property({ type: Array })
    assets: Asset[] = [];

    @property({ type: Number })
    activeIndex: number = 0;

    // Lifecycle Hooks

    firstUpdated() {
        this.classList.add('ImageSwitcher');
    }

    // render
    
    render() {
        const activeAsset = this.assets[this.activeIndex];
        return html`
            <figure class="ImageSwitcher-figure ImageSwitcher-figure--display">
                <img 
                    src="${ activeAsset.src }"
                    title="${ activeAsset.title }"
                    alt="${ activeAsset.alt }"
                />
            </figure>
            ${ this.assets.map((asset, i) => this.figureTemplate(asset, i)) }
        `;
    }

    createRenderRoot() {
        return this;
    }

    // templates

    figureTemplate(asset: Asset, index: number): TemplateResult {
        return html`
            <figure class="ImageSwitcher-figure ImageSwitcher-figure--nav" tabindex="0">
                <img 
                    src="${ asset.thumbnailSrc }"
                    title="${ asset.title }"
                    alt="${ asset.alt }"
                    @click="${ () => { this.activeIndex = index } }"
                />
            </figure>
        `;
    }
}